module.exports = __webpack_public_path__ + "h5/img/shouquanma-info.a6e9fe30.jpg";